export const generateChatRoomId =( email1, email2 )=>{

    const sortedArray= [email1,email2].sort();
    const result = sortedArray[0]+"|"+sortedArray[1];
    return result.toLowerCase();
}